import { coachPaths } from "../routes/coach";
import { findAJobPaths } from "../routes/find-a-job";
import { hireTalentPaths } from "../routes/hire-talent";
import { getHireTalentFormData, getProfile, setProfile, setToken } from "./pip";
import { normalizeHireTalentProfile } from "./hireTalentProfile";
import { createSocketConnection } from "../redux/features/chat/socket";
import { fetchfreelancerProfile } from "../redux/features/find-a-job/actions/authAction";
import { fetchHireTalentProfile } from "../redux/features/hire-talent/actions/authAction";
import {
  setIsFindAJobModal,
  setRegisterStep,
} from "../redux/features/find-a-job/reducers/authReducer";
import {
  setIsHireTalentModal,
  setPage,
  setStartStep,
} from "../redux/features/hire-talent/reducers/authReducer";

export const handlePostLoginFlow = ({
  response,
  dispatch,
  navigate,
  onClose,
  skipCloseOnHireTalentModal = false,
}) => {
  const payload = response?.data || response;
  const token = payload?.token;
  const userData = payload?.userData;
  const close = () => {
    if (typeof onClose === "function") {
      onClose();
    };
  };
  if (!userData) return;
  if (userData?.role == "COACH") {
    setToken("coach", token);
    setProfile("coach", userData);
    localStorage.removeItem('hire-talent_token_nuvio');
    localStorage.removeItem('hire-talent_profile_nuvio');
    localStorage.removeItem('freelancer_profile_nuvio');
    localStorage.removeItem('freelancer_token_nuvio');
    if (userData?.active_subscription) {
      navigate(coachPaths?.CoachDashboard);
    } else {
      navigate(coachPaths?.CoachSubscription);
    }
  } else if (userData?.role == "OPEN_TALENT") {
    setToken("freelancer", token);
    setProfile("freelancer", userData);
    localStorage.removeItem('hire-talent_token_nuvio');
    localStorage.removeItem('hire-talent_profile_nuvio');
    localStorage.removeItem('coach_profile_nuvio');
    localStorage.removeItem('coach_token_nuvio');
    dispatch(fetchfreelancerProfile()).then((res) => {
      const data = res?.payload?.data;
      if (data) {
        const existing = getProfile("freelancer") || {};
        const merged = {
          ...data,
          full_name:
            data.full_name ||
            existing.full_name ||
            `${data.first_name || ""} ${data.last_name || ""}`.trim(),
          first_name: data.first_name || existing.first_name || data.full_name || "",
          last_name: data.last_name || existing.last_name || "",
        };
        setProfile("freelancer", merged);
      }
    });
    if (userData?.open_talent?.talent_type == "FREELANCER") {
      if (userData?.signup_step < 5) {
        switch (userData?.signup_step) {
          case 1:
            close();
            dispatch(setRegisterStep("profileStep1"));
            dispatch(setIsFindAJobModal(true));
            break;
          case 2:
            close();
            dispatch(setRegisterStep("profileStep2"));
            dispatch(setIsFindAJobModal(true));
            break;
          case 3:
            close();
            dispatch(setRegisterStep("profileStep3"));
            dispatch(setIsFindAJobModal(true));
            break;
          case 4:
            close();
            dispatch(setRegisterStep("profileStep4"));
            dispatch(setIsFindAJobModal(true));
            break;
          default:
            break;
        }
      } else if (userData?.active_subscription) {
        close();
        dispatch(setIsFindAJobModal(false));
        createSocketConnection(token);
        navigate(findAJobPaths?.Dashboard);
      } else {
        close();
        dispatch(setRegisterStep("subscription"));
        dispatch(setIsFindAJobModal(true));
      }
    } else {
      if (userData?.signup_step < 5) {
        switch (userData?.signup_step) {
          case 1:
            close();
            dispatch(setRegisterStep("profileStep1"));
            dispatch(setIsFindAJobModal(true));
            break;
          case 2:
            close();
            dispatch(setRegisterStep("profileStep2"));
            dispatch(setIsFindAJobModal(true));
            break;
          case 3:
            close();
            dispatch(setRegisterStep("profileStep3"));
            dispatch(setIsFindAJobModal(true));
            break;
          case 4:
            close();
            dispatch(setRegisterStep("profileStep4"));
            dispatch(setIsFindAJobModal(true));
            break;

          default:
            break;
        }
      } else {
        close();
        dispatch(setIsFindAJobModal(false));
        createSocketConnection(token);
        navigate(findAJobPaths?.Dashboard);
      }
    }
  } else if (userData?.role == "HIRE_TALENT") {
    setToken("hire-talent", token);
    setProfile("hire-talent", userData);
    localStorage.removeItem('freelancer_profile_nuvio');
    localStorage.removeItem('freelancer_token_nuvio');
    localStorage.removeItem('coach_profile_nuvio');
    localStorage.removeItem('coach_token_nuvio');
    dispatch(fetchHireTalentProfile({ force: true })).then((res) => {
      const data = res?.payload?.data;
      const existing = getProfile("hire-talent") || {};
      const normalized = normalizeHireTalentProfile({
        ...existing,
        ...(data || {}),
        ...(userData?.hiretalent || {}),
      });
      setProfile("hire-talent", normalized);

      const tempStep = getHireTalentFormData()?.signup_step || 1;
      const hasContact = !!(
        normalized.primary_contact_name ||
        normalized.primary_contact_email ||
        normalized.primary_contact_phone
      );
      const hasHiring = !!(
        (normalized.talent_types || []).length ||
        (normalized.engagement_types || []).length ||
        normalized.project_title ||
        normalized.project_description ||
        normalized.required_skills
      );
      const hasWorkEnv = !!(
        normalized.preferred_timezone ||
        (normalized.communication_tools || []).length ||
        normalized.collaboration_type ||
        normalized.consent_accuracy ||
        normalized.consent_contact
      );

      const signupStep = Number(userData?.signup_step || 1);
      let nextStep = signupStep + 1;
      if (!hasContact) nextStep = 2;
      else if (!hasHiring || !hasWorkEnv) nextStep = 3;
      if (nextStep < 2) nextStep = 2;

      if (tempStep > nextStep) nextStep = tempStep;

      if (nextStep <= 3) {
        dispatch(setStartStep(nextStep));
        dispatch(setPage("afterLogin"));
        dispatch(setIsHireTalentModal(true));
        if (!skipCloseOnHireTalentModal) close();
      } else {
        createSocketConnection(token);
        navigate(hireTalentPaths?.Dashboard);
        close();
      }
    });
  };
};
